import { Component, ElementRef, Input, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
    selector: 'f-facet',
    templateUrl: './f-facet.component.html',
    standalone: false
})
export class FFacetComponent {
  // @Input() name: string;
  get isEmpty(): boolean {
    const ne = this.el.nativeElement as HTMLElement;
    return ne?.children?.length === 0;
  }
  constructor(public el: ElementRef){}
}
@NgModule({
  imports: [CommonModule],
  exports: [FFacetComponent],
  declarations: [FFacetComponent]
})
export class FFacetModule { }